import { __assign, __rest } from "tslib";
import React from 'react';
import ShopThumb from './ShopThumb';
import { commissionAdapter, printAdapter, premiumContentAdapter, } from './Adapters';
import { ShopThumbType } from './types';
import dasContentAdapter from './Adapters/das';
var ShopThumbFactory = function (_a) {
    var type = _a.type, props = __rest(_a, ["type"]);
    var adapterType = undefined;
    if (type) {
        adapterType = type;
    }
    else {
        if (props.deviation.hasOwnProperty('commission')) {
            adapterType = ShopThumbType.COMMISSION;
        }
        else if (props.deviation.hasOwnProperty('print')) {
            adapterType = ShopThumbType.PRINT;
        }
        else if (props.deviation.hasOwnProperty('pcp')) {
            adapterType = ShopThumbType.PCP;
        }
        else if (props.deviation.hasOwnProperty('asset')) {
            adapterType = ShopThumbType.DAS;
        }
    }
    var shopThumbProps;
    switch (adapterType) {
        case ShopThumbType.COMMISSION:
            shopThumbProps = commissionAdapter(props);
            break;
        case ShopThumbType.PRINT:
            shopThumbProps = printAdapter(props);
            break;
        case ShopThumbType.PCP:
            shopThumbProps = premiumContentAdapter(props);
            break;
        case ShopThumbType.DAS:
            shopThumbProps = dasContentAdapter(props);
            break;
        default:
            shopThumbProps = props;
    }
    return React.createElement(ShopThumb, __assign({}, shopThumbProps));
};
export default ShopThumbFactory;
//# sourceMappingURL=factory.js.map